// extracted by css-extract-rspack-plugin
export default {"closeButtonContainer":"closeButtonContainer-Opytk1","collaboratorName":"collaboratorName-Qy7I5Z text-xl-medium"};